// extracted by mini-css-extract-plugin
export default {"scroll":"MessagesTab_scroll__hW+Ap","loader":"MessagesTab_loader__qPtAf"};